import { type RbTableRowId, useRbSystemAlert } from "@scmlatam/web-ui";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { reportService } from "../services/service";

const useDeleteConfirm = (
  reload: () => Promise<void>,
  selectedRowIds: Set<RbTableRowId>,
) => {
  const { t } = useTranslation("execute_report.confirm_delete_result");
  const { showAlert, closeAlert } = useRbSystemAlert();

  const [open, setOpen] = useState<boolean>(false);

  const deleteResult = async () => {
    reportService.deleteResult({
      alert: { t, showAlert, closeAlert },
      params: {
        setLoading: () => {},
        reload,
        closing: () => {
          setOpen(false);
        },
        body: {
          where_delete: {
            id: Array.from(selectedRowIds),
          },
        },
      },
    });
  };

  return {
    t,
    open,
    setOpen,
    deleteResult,
  };
};

export { useDeleteConfirm };
